import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 24px;
  cursor: pointer;
  height: 80px;
  justify-content: space-between;
`;

export const ID = styled.h4`
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  padding-right: 24px;
  border-right: 1px solid
    ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N300
        : props.theme.atlas.semantic.color.outline.fixed};
  margin: 14px 0px;
`;

export const Created = styled.h4`
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N600
      : props.theme.atlas.semantic.color.type.muted};
  padding-left: 24px;
  margin: 14px 0px;
`;

export const EventDetailsWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;
